export interface PhoneCountry {
  iso: string;
  dial: string;
  name: string;
}

export const PHONE_COUNTRIES: PhoneCountry[] = [
  { iso: 'AF', dial: '93', name: 'Afghanistan' },
  { iso: 'AL', dial: '355', name: 'Albania' },
  { iso: 'DZ', dial: '213', name: 'Algeria' },
  { iso: 'AS', dial: '1', name: 'American Samoa' },
  { iso: 'AD', dial: '376', name: 'Andorra' },
  { iso: 'AO', dial: '244', name: 'Angola' },
  { iso: 'AI', dial: '1', name: 'Anguilla' },
  { iso: 'AG', dial: '1', name: 'Antigua & Barbuda' },
  { iso: 'AR', dial: '54', name: 'Argentina' },
  { iso: 'AM', dial: '374', name: 'Armenia' },
  { iso: 'AW', dial: '297', name: 'Aruba' },
  { iso: 'AC', dial: '247', name: 'Ascension Island' },
  { iso: 'AU', dial: '61', name: 'Australia' },
  { iso: 'AT', dial: '43', name: 'Austria' },
  { iso: 'AZ', dial: '994', name: 'Azerbaijan' },
  { iso: 'BS', dial: '1', name: 'Bahamas' },
  { iso: 'BH', dial: '973', name: 'Bahrain' },
  { iso: 'BD', dial: '880', name: 'Bangladesh' },
  { iso: 'BB', dial: '1', name: 'Barbados' },
  { iso: 'BY', dial: '375', name: 'Belarus' },
  { iso: 'BE', dial: '32', name: 'Belgium' },
  { iso: 'BZ', dial: '501', name: 'Belize' },
  { iso: 'BJ', dial: '229', name: 'Benin' },
  { iso: 'BM', dial: '1', name: 'Bermuda' },
  { iso: 'BT', dial: '975', name: 'Bhutan' },
  { iso: 'BO', dial: '591', name: 'Bolivia' },
  { iso: 'BA', dial: '387', name: 'Bosnia & Herzegovina' },
  { iso: 'BW', dial: '267', name: 'Botswana' },
  { iso: 'BR', dial: '55', name: 'Brazil' },
  { iso: 'IO', dial: '246', name: 'British Indian Ocean Territory' },
  { iso: 'VG', dial: '1', name: 'British Virgin Islands' },
  { iso: 'BN', dial: '673', name: 'Brunei' },
  { iso: 'BG', dial: '359', name: 'Bulgaria' },
  { iso: 'BF', dial: '226', name: 'Burkina Faso' },
  { iso: 'BI', dial: '257', name: 'Burundi' },
  { iso: 'KH', dial: '855', name: 'Cambodia' },
  { iso: 'CM', dial: '237', name: 'Cameroon' },
  { iso: 'CA', dial: '1', name: 'Canada' },
  { iso: 'CV', dial: '238', name: 'Cape Verde' },
  { iso: 'BQ', dial: '599', name: 'Caribbean Netherlands' },
  { iso: 'KY', dial: '1', name: 'Cayman Islands' },
  { iso: 'CF', dial: '236', name: 'Central African Republic' },
  { iso: 'TD', dial: '235', name: 'Chad' },
  { iso: 'CL', dial: '56', name: 'Chile' },
  { iso: 'CN', dial: '86', name: 'China' },
  { iso: 'CX', dial: '61', name: 'Christmas Island' },
  { iso: 'CC', dial: '61', name: 'Cocos (Keeling) Islands' },
  { iso: 'CO', dial: '57', name: 'Colombia' },
  { iso: 'KM', dial: '269', name: 'Comoros' },
  { iso: 'CG', dial: '242', name: 'Congo - Brazzaville' },
  { iso: 'CD', dial: '243', name: 'Congo - Kinshasa' },
  { iso: 'CK', dial: '682', name: 'Cook Islands' },
  { iso: 'CR', dial: '506', name: 'Costa Rica' },
  { iso: 'HR', dial: '385', name: 'Croatia' },
  { iso: 'CU', dial: '53', name: 'Cuba' },
  { iso: 'CW', dial: '599', name: 'Curaçao' },
  { iso: 'CY', dial: '357', name: 'Cyprus' },
  { iso: 'CZ', dial: '420', name: 'Czechia' },
  { iso: 'CI', dial: '225', name: 'Côte d’Ivoire' },
  { iso: 'DK', dial: '45', name: 'Denmark' },
  { iso: 'DJ', dial: '253', name: 'Djibouti' },
  { iso: 'DM', dial: '1', name: 'Dominica' },
  { iso: 'DO', dial: '1', name: 'Dominican Republic' },
  { iso: 'EC', dial: '593', name: 'Ecuador' },
  { iso: 'EG', dial: '20', name: 'Egypt' },
  { iso: 'SV', dial: '503', name: 'El Salvador' },
  { iso: 'GQ', dial: '240', name: 'Equatorial Guinea' },
  { iso: 'ER', dial: '291', name: 'Eritrea' },
  { iso: 'EE', dial: '372', name: 'Estonia' },
  { iso: 'SZ', dial: '268', name: 'Eswatini' },
  { iso: 'ET', dial: '251', name: 'Ethiopia' },
  { iso: 'FK', dial: '500', name: 'Falkland Islands' },
  { iso: 'FO', dial: '298', name: 'Faroe Islands' },
  { iso: 'FJ', dial: '679', name: 'Fiji' },
  { iso: 'FI', dial: '358', name: 'Finland' },
  { iso: 'FR', dial: '33', name: 'France' },
  { iso: 'GF', dial: '594', name: 'French Guiana' },
  { iso: 'PF', dial: '689', name: 'French Polynesia' },
  { iso: 'GA', dial: '241', name: 'Gabon' },
  { iso: 'GM', dial: '220', name: 'Gambia' },
  { iso: 'GE', dial: '995', name: 'Georgia' },
  { iso: 'DE', dial: '49', name: 'Germany' },
  { iso: 'GH', dial: '233', name: 'Ghana' },
  { iso: 'GI', dial: '350', name: 'Gibraltar' },
  { iso: 'GR', dial: '30', name: 'Greece' },
  { iso: 'GL', dial: '299', name: 'Greenland' },
  { iso: 'GD', dial: '1', name: 'Grenada' },
  { iso: 'GP', dial: '590', name: 'Guadeloupe' },
  { iso: 'GU', dial: '1', name: 'Guam' },
  { iso: 'GT', dial: '502', name: 'Guatemala' },
  { iso: 'GG', dial: '44', name: 'Guernsey' },
  { iso: 'GN', dial: '224', name: 'Guinea' },
  { iso: 'GW', dial: '245', name: 'Guinea-Bissau' },
  { iso: 'GY', dial: '592', name: 'Guyana' },
  { iso: 'HT', dial: '509', name: 'Haiti' },
  { iso: 'HN', dial: '504', name: 'Honduras' },
  { iso: 'HK', dial: '852', name: 'Hong Kong SAR China' },
  { iso: 'HU', dial: '36', name: 'Hungary' },
  { iso: 'IS', dial: '354', name: 'Iceland' },
  { iso: 'IN', dial: '91', name: 'India' },
  { iso: 'ID', dial: '62', name: 'Indonesia' },
  { iso: 'IR', dial: '98', name: 'Iran' },
  { iso: 'IQ', dial: '964', name: 'Iraq' },
  { iso: 'IE', dial: '353', name: 'Ireland' },
  { iso: 'IM', dial: '44', name: 'Isle of Man' },
  { iso: 'IL', dial: '972', name: 'Israel' },
  { iso: 'IT', dial: '39', name: 'Italy' },
  { iso: 'JM', dial: '1', name: 'Jamaica' },
  { iso: 'JP', dial: '81', name: 'Japan' },
  { iso: 'JE', dial: '44', name: 'Jersey' },
  { iso: 'JO', dial: '962', name: 'Jordan' },
  { iso: 'KZ', dial: '7', name: 'Kazakhstan' },
  { iso: 'KE', dial: '254', name: 'Kenya' },
  { iso: 'KI', dial: '686', name: 'Kiribati' },
  { iso: 'XK', dial: '383', name: 'Kosovo' },
  { iso: 'KW', dial: '965', name: 'Kuwait' },
  { iso: 'KG', dial: '996', name: 'Kyrgyzstan' },
  { iso: 'LA', dial: '856', name: 'Laos' },
  { iso: 'LV', dial: '371', name: 'Latvia' },
  { iso: 'LB', dial: '961', name: 'Lebanon' },
  { iso: 'LS', dial: '266', name: 'Lesotho' },
  { iso: 'LR', dial: '231', name: 'Liberia' },
  { iso: 'LY', dial: '218', name: 'Libya' },
  { iso: 'LI', dial: '423', name: 'Liechtenstein' },
  { iso: 'LT', dial: '370', name: 'Lithuania' },
  { iso: 'LU', dial: '352', name: 'Luxembourg' },
  { iso: 'MO', dial: '853', name: 'Macao SAR China' },
  { iso: 'MG', dial: '261', name: 'Madagascar' },
  { iso: 'MW', dial: '265', name: 'Malawi' },
  { iso: 'MY', dial: '60', name: 'Malaysia' },
  { iso: 'MV', dial: '960', name: 'Maldives' },
  { iso: 'ML', dial: '223', name: 'Mali' },
  { iso: 'MT', dial: '356', name: 'Malta' },
  { iso: 'MH', dial: '692', name: 'Marshall Islands' },
  { iso: 'MQ', dial: '596', name: 'Martinique' },
  { iso: 'MR', dial: '222', name: 'Mauritania' },
  { iso: 'MU', dial: '230', name: 'Mauritius' },
  { iso: 'YT', dial: '262', name: 'Mayotte' },
  { iso: 'MX', dial: '52', name: 'Mexico' },
  { iso: 'FM', dial: '691', name: 'Micronesia' },
  { iso: 'MD', dial: '373', name: 'Moldova' },
  { iso: 'MC', dial: '377', name: 'Monaco' },
  { iso: 'MN', dial: '976', name: 'Mongolia' },
  { iso: 'ME', dial: '382', name: 'Montenegro' },
  { iso: 'MS', dial: '1', name: 'Montserrat' },
  { iso: 'MA', dial: '212', name: 'Morocco' },
  { iso: 'MZ', dial: '258', name: 'Mozambique' },
  { iso: 'MM', dial: '95', name: 'Myanmar (Burma)' },
  { iso: 'NA', dial: '264', name: 'Namibia' },
  { iso: 'NR', dial: '674', name: 'Nauru' },
  { iso: 'NP', dial: '977', name: 'Nepal' },
  { iso: 'NL', dial: '31', name: 'Netherlands' },
  { iso: 'NC', dial: '687', name: 'New Caledonia' },
  { iso: 'NZ', dial: '64', name: 'New Zealand' },
  { iso: 'NI', dial: '505', name: 'Nicaragua' },
  { iso: 'NE', dial: '227', name: 'Niger' },
  { iso: 'NG', dial: '234', name: 'Nigeria' },
  { iso: 'NU', dial: '683', name: 'Niue' },
  { iso: 'NF', dial: '672', name: 'Norfolk Island' },
  { iso: 'KP', dial: '850', name: 'North Korea' },
  { iso: 'MK', dial: '389', name: 'North Macedonia' },
  { iso: 'MP', dial: '1', name: 'Northern Mariana Islands' },
  { iso: 'NO', dial: '47', name: 'Norway' },
  { iso: 'OM', dial: '968', name: 'Oman' },
  { iso: 'PK', dial: '92', name: 'Pakistan' },
  { iso: 'PW', dial: '680', name: 'Palau' },
  { iso: 'PS', dial: '970', name: 'Palestinian Territories' },
  { iso: 'PA', dial: '507', name: 'Panama' },
  { iso: 'PG', dial: '675', name: 'Papua New Guinea' },
  { iso: 'PY', dial: '595', name: 'Paraguay' },
  { iso: 'PE', dial: '51', name: 'Peru' },
  { iso: 'PH', dial: '63', name: 'Philippines' },
  { iso: 'PL', dial: '48', name: 'Poland' },
  { iso: 'PT', dial: '351', name: 'Portugal' },
  { iso: 'PR', dial: '1', name: 'Puerto Rico' },
  { iso: 'QA', dial: '974', name: 'Qatar' },
  { iso: 'RO', dial: '40', name: 'Romania' },
  { iso: 'RU', dial: '7', name: 'Russia' },
  { iso: 'RW', dial: '250', name: 'Rwanda' },
  { iso: 'RE', dial: '262', name: 'Réunion' },
  { iso: 'WS', dial: '685', name: 'Samoa' },
  { iso: 'SM', dial: '378', name: 'San Marino' },
  { iso: 'SA', dial: '966', name: 'Saudi Arabia' },
  { iso: 'SN', dial: '221', name: 'Senegal' },
  { iso: 'RS', dial: '381', name: 'Serbia' },
  { iso: 'SC', dial: '248', name: 'Seychelles' },
  { iso: 'SL', dial: '232', name: 'Sierra Leone' },
  { iso: 'SG', dial: '65', name: 'Singapore' },
  { iso: 'SX', dial: '1', name: 'Sint Maarten' },
  { iso: 'SK', dial: '421', name: 'Slovakia' },
  { iso: 'SI', dial: '386', name: 'Slovenia' },
  { iso: 'SB', dial: '677', name: 'Solomon Islands' },
  { iso: 'SO', dial: '252', name: 'Somalia' },
  { iso: 'ZA', dial: '27', name: 'South Africa' },
  { iso: 'KR', dial: '82', name: 'South Korea' },
  { iso: 'SS', dial: '211', name: 'South Sudan' },
  { iso: 'ES', dial: '34', name: 'Spain' },
  { iso: 'LK', dial: '94', name: 'Sri Lanka' },
  { iso: 'BL', dial: '590', name: 'St. Barthélemy' },
  { iso: 'SH', dial: '290', name: 'St. Helena' },
  { iso: 'KN', dial: '1', name: 'St. Kitts & Nevis' },
  { iso: 'LC', dial: '1', name: 'St. Lucia' },
  { iso: 'MF', dial: '590', name: 'St. Martin' },
  { iso: 'PM', dial: '508', name: 'St. Pierre & Miquelon' },
  { iso: 'VC', dial: '1', name: 'St. Vincent & Grenadines' },
  { iso: 'SD', dial: '249', name: 'Sudan' },
  { iso: 'SR', dial: '597', name: 'Suriname' },
  { iso: 'SJ', dial: '47', name: 'Svalbard & Jan Mayen' },
  { iso: 'SE', dial: '46', name: 'Sweden' },
  { iso: 'CH', dial: '41', name: 'Switzerland' },
  { iso: 'SY', dial: '963', name: 'Syria' },
  { iso: 'ST', dial: '239', name: 'São Tomé & Príncipe' },
  { iso: 'TW', dial: '886', name: 'Taiwan' },
  { iso: 'TJ', dial: '992', name: 'Tajikistan' },
  { iso: 'TZ', dial: '255', name: 'Tanzania' },
  { iso: 'TH', dial: '66', name: 'Thailand' },
  { iso: 'TL', dial: '670', name: 'Timor-Leste' },
  { iso: 'TG', dial: '228', name: 'Togo' },
  { iso: 'TK', dial: '690', name: 'Tokelau' },
  { iso: 'TO', dial: '676', name: 'Tonga' },
  { iso: 'TT', dial: '1', name: 'Trinidad & Tobago' },
  { iso: 'TA', dial: '290', name: 'Tristan da Cunha' },
  { iso: 'TN', dial: '216', name: 'Tunisia' },
  { iso: 'TR', dial: '90', name: 'Turkey' },
  { iso: 'TM', dial: '993', name: 'Turkmenistan' },
  { iso: 'TC', dial: '1', name: 'Turks & Caicos Islands' },
  { iso: 'TV', dial: '688', name: 'Tuvalu' },
  { iso: 'VI', dial: '1', name: 'U.S. Virgin Islands' },
  { iso: 'UG', dial: '256', name: 'Uganda' },
  { iso: 'UA', dial: '380', name: 'Ukraine' },
  { iso: 'AE', dial: '971', name: 'United Arab Emirates' },
  { iso: 'GB', dial: '44', name: 'United Kingdom' },
  { iso: 'US', dial: '1', name: 'United States' },
  { iso: 'UY', dial: '598', name: 'Uruguay' },
  { iso: 'UZ', dial: '998', name: 'Uzbekistan' },
  { iso: 'VU', dial: '678', name: 'Vanuatu' },
  { iso: 'VA', dial: '39', name: 'Vatican City' },
  { iso: 'VE', dial: '58', name: 'Venezuela' },
  { iso: 'VN', dial: '84', name: 'Vietnam' },
  { iso: 'WF', dial: '681', name: 'Wallis & Futuna' },
  { iso: 'EH', dial: '212', name: 'Western Sahara' },
  { iso: 'YE', dial: '967', name: 'Yemen' },
  { iso: 'ZM', dial: '260', name: 'Zambia' },
  { iso: 'ZW', dial: '263', name: 'Zimbabwe' },
  { iso: 'AX', dial: '358', name: 'Åland Islands' },
];

export const findCountryByIso = (iso?: string | null): PhoneCountry | undefined =>
  iso ? PHONE_COUNTRIES.find((c) => c.iso === iso.toUpperCase()) : undefined;

const PRIMARY_COUNTRY_BY_DIAL: Record<string, string> = {
  1: 'US',
  7: 'RU',
  39: 'IT',
  44: 'GB',
  47: 'NO',
  61: 'AU',
  212: 'MA',
  262: 'RE',
  290: 'SH',
  358: 'FI',
  590: 'GP',
  599: 'CW',
};

export const findCountryByDial = (dial: string): PhoneCountry | undefined => {
  const matches = PHONE_COUNTRIES.filter((c) => dial.startsWith(c.dial));
  if (matches.length === 0) return undefined;
  const longest = matches.reduce((len, c) => Math.max(len, c.dial.length), 0);
  const candidates = matches.filter((c) => c.dial.length === longest);
  const primaryIso = PRIMARY_COUNTRY_BY_DIAL[candidates[0].dial];
  return candidates.find((c) => c.iso === primaryIso) ?? candidates[0];
};

export const splitE164 = (value: string): { country?: PhoneCountry; national: string } => {
  if (!value.startsWith('+')) return { national: value };
  const digits = value.slice(1);
  const country = findCountryByDial(digits);
  return country ? { country, national: digits.slice(country.dial.length) } : { national: digits };
};

export const toE164 = (dial: string, national: string): string => {
  const digits = national.replace(/\D/g, '').replace(/^0+/, '');
  return digits ? `+${dial}${digits}` : '';
};

const startsWithDialCode = (digits: string, dial: string): boolean =>
  digits.startsWith(dial) &&
  digits.length >= 10 &&
  digits.length - dial.length >= 8 &&
  (dial.length > 1 || digits.length >= 11);

/**
 * Turns whatever was typed or pasted into the national box into E.164. A leading + or 00 is read as
 * an international number and picks its own country; a number that already carries the selected
 * country's dial code keeps it once rather than twice. Unresolved international input is passed
 * through as `+digits` so the caller can keep showing it while the user types.
 */
export const parseNationalInput = (input: string, dial: string): string => {
  const trimmed = input.trim();
  const international = trimmed.match(/^(?:\+|00)(.*)$/);

  if (international) {
    const digits = international[1].replace(/\D/g, '');
    const country = findCountryByDial(digits);
    if (!country) return `+${digits}`;
    return toE164(country.dial, digits.slice(country.dial.length)) || `+${country.dial}`;
  }

  const digits = trimmed.replace(/\D/g, '');
  return startsWithDialCode(digits, dial) ? toE164(dial, digits.slice(dial.length)) : toE164(dial, digits);
};
